import { render, staticRenderFns } from "./testTitle.vue?vue&type=template&id=027e500c&scoped=true"
import script from "./testTitle.vue?vue&type=script&lang=js"
export * from "./testTitle.vue?vue&type=script&lang=js"
import style0 from "./testTitle.vue?vue&type=style&index=0&id=027e500c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027e500c",
  null
  
)

export default component.exports